import { action } from 'satcheljs';

export interface ON_ITEM_PART_SELECTEDActionMessage {
    conversationNodeId: string;
    conversationId: string;
}
const defaultExport: (
    conversationNodeId: string,
    conversationId: string
) => ON_ITEM_PART_SELECTEDActionMessage = action(
    'ON_ITEM_PART_SELECTED',
    (conversationNodeId: string, conversationId: string): ON_ITEM_PART_SELECTEDActionMessage => ({
        conversationNodeId,
        conversationId,
    })
);
export default defaultExport;
